export enum CargoIntegrationSortType {
    Id,
    Name,
    IsDeleted
}
